import { showConfirmationModal } from '../../confirmation-modal/confirmationModalReducer';
import { Dispatch } from 'redux';

type Props = {
  onSubmit: () => Promise<void>;
  warnOnFinal: boolean;
  warnOnTruePositive: boolean;
  statusName: string;
  dispatch: Dispatch<any>;
};

const confirmStatus = async ({ onSubmit, warnOnFinal, warnOnTruePositive, statusName, dispatch }: Props) => {
  if (warnOnFinal || warnOnTruePositive) {
    dispatch(
      showConfirmationModal({
        title: `Confirm you want to set this alert to ${statusName}`,
        confirmationText: 'Yes',
        cancelText: 'No',
        onConfirm: async () => {
          await onSubmit();
        },
      })
    );
  } else {
    await onSubmit();
  }
};

export default confirmStatus;
